import { mapActions, mapGetters, mapMutations } from 'vuex';
import StarRating from 'vue-star-rating';
import InputSelect from '@/components/custom/InputSelect/index.vue';

import validation from '@/mixins/validation';
import { email, minValue, required } from 'vuelidate/lib/validators';
export default {
  name: 'ReviewCreateModal',
  components: {
    InputSelect,
    StarRating
  },

  data() {
    return {
      payload: {
        name: '',
        email: '',
        brandId: null,
        message: '',
        rating: 0
      },
      isLoading: false,
      validationErrors: {},
      brands: [],
      products: []
    };
  },
  mixins: [validation],
  validations: {
    payload: {
      name: { required },
      email: { required, email },
      productId: { required },
      message: { required },
      rating: { required, minValue: minValue(1) }
    }
  },
  created() {
    this._initializeForm();
    if (this.reviewProducts.length) return;
    this.getReviewProducts();
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      reviewProducts: 'reviews/reviewProducts'
    }),
    nameErrors() {
      return this.computeErrors('payload', 'name', {
        required: 'validationRequired'
      });
    },
    emailErrors() {
      return this.computeErrors('payload', 'email', {
        email: 'validation.email'
      });
    },
    productErrors() {
      return this.computeErrors('payload', 'productId', {
        required: 'validationRequired'
      });
    },
    ratingErrors() {
      return this.computeErrors('payload', 'rating', {
        minValue: 'validationRequired',
        required: 'validationRequired'
      });
    },

    messageErrors() {
      return this.computeErrors('payload', 'message', {
        required: 'validationRequired'
      });
    }
  },
  methods: {
    ...mapMutations({
      modalClose: 'app/MODAL_CLOSE'
    }),
    ...mapActions({
      addProductComment: 'comments/ADD_PRODUCT_COMMENT',
      getReviewProducts: 'reviews/GET_REVIEWS_PRODUCTS'
    }),

    _initializeForm() {
      if (this.user) {
        this.payload.name = this.user.name || '';
        this.payload.email = this.user.email || '';
      }
    },

    onProductChange(data) {
      this.payload.productId = data.id;
      console.log('onProductChange', data);
    },

    onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.isLoading = true;
      try {
        let { productId, ...otherData } = this.payload;
        let payload = { ...otherData, product_id: productId };

        this.addProductComment(payload).then(() => {
          this.$toasted.success(this.$t('toast.successFeedbackSend'));
          this.modalClose('reviewCreateModal');
        });
      } catch (error) {
        this.$toasted.error(this.$t('validationRequired'));
      } finally {
        this.isLoading = false;
      }
    }
  }
};
